import { render, staticRenderFns } from "./FeeResource.vue?vue&type=template&id=3dfb3b8c&"
import script from "./FeeResource.vue?vue&type=script&lang=js&"
export * from "./FeeResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports